'use client';

import { Button } from '@noirproperties/ui/components/ui/button';
import type { MouseEventHandler } from 'react';
import { useGallery } from './gallery-context';

type GalleryButtonProps = {
  index?: number;
  children: React.ReactNode;
};

export function GalleryButton({ index = 0, children }: GalleryButtonProps) {
  const { openGallery } = useGallery();

  const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    openGallery(index);
  };

  return (
    <Button
      className="font-semibold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
      onClick={handleClick}
      size="default"
      variant="default"
    >
      {children}
    </Button>
  );
}
